import _ from "lodash";

import { LogicProposalComponent } from "lib/frontend/cm/utils/types";
import { Company, Prisma, Proposal, Review } from "prisma/cm/client";

export * from "./bonus-target";
export * from "./bonus";
export * from "./salary";
export * from "./equity";
export * from "./outliers";

export function getProposalDbFieldToAutofill(component: string) {
  // @ts-expect-error TS2339
  const proposalDbFieldToAutofill: keyof Proposal =
    component === "salary" ? "raise" : component === "bonus-target" ? "bonusTarget" : component;
  return proposalDbFieldToAutofill;
}

export function getIsPromoted<P extends { rangeId: number | null; title: string | null }>(
  proposal: P,
): boolean {
  return !_.isNil(proposal.rangeId) || !_.isNil(proposal.title);
}

export function filterForEligibility<
  P extends Pick<
    Proposal,
    "eligibleForBonus" | "eligibleForEquity" | "eligibleForSalary" | "eligibleForPromotion"
  >,
>(proposals: P[], component: LogicProposalComponent | "Promotion"): P[] {
  return proposals.filter((proposal) => {
    switch (component) {
      case LogicProposalComponent.SALARY:
        return proposal.eligibleForSalary;
      case LogicProposalComponent.BONUS:
        return proposal.eligibleForBonus;
      case LogicProposalComponent.EQUITY:
        return proposal.eligibleForEquity;
      case "Promotion":
        return proposal.eligibleForPromotion;
      default:
        return false;
    }
  });
}

export function getDefaultCreateProposalData(
  review: Review,
  company: Company,
): Partial<Prisma.ProposalCreateManyInput> {
  return {
    adjustVariableTarget: company?.autoCalculateVariableTargetIncrease,
    raiseInputMode: review.defaultInputMode,
    bonusInputMode: review.defaultInputMode,
    suggestedRaiseInputMode: review.defaultInputMode,
    suggestedBonusInputMode: review.defaultInputMode,
  };
}
